import { config, html } from '@ingka/webc-tools';
// @ts-ignore
const styles = '@keyframes skapa-message-in{0%{opacity:0;transform:translateY(1.5rem)}to{opacity:1;transform:translateY(0)}}@keyframes skapa-message-out{0%{opacity:1;transform:translateY(0);visibility:visible}99%{opacity:0;transform:translateY(-1.5rem);visibility:visible}to{opacity:0;transform:translateY(-1.5rem);visibility:hidden}}:host{align-items:center;display:flex;flex-direction:column;justify-content:center;min-height:5rem;position:relative}slot[name=message]{--skapa-loading-transition-duration:100ms;display:block;position:relative;text-align:center;width:100%}slot[name=message]::slotted(*){font-size:1rem;left:0;line-height:1.625;position:absolute;text-align:center;width:100%}slot[name=message]::slotted(:not(:last-of-type)){animation:skapa-message-out var(--skapa-loading-transition-duration) cubic-bezier(.4,0,.4,1) both}slot[name=message]::slotted(:last-of-type){animation:skapa-message-in var(--skapa-loading-transition-duration) cubic-bezier(.4,0,.4,1) backwards;animation-delay:var(--skapa-loading-transition-duration)}:host([leading]) slot[name=message]{text-align:start}:host([leading]) slot[name=message]::slotted(*){text-align:start}@media (prefers-reduced-motion:reduce){slot[name=message]{--skapa-loading-transition-duration:0ms}}';
// @ts-ignore
const lightStyleRaw = '@keyframes skapa-message-in{0%{opacity:0;transform:translateY(1.5rem)}to{opacity:1;transform:translateY(0)}}@keyframes skapa-message-out{0%{opacity:1;transform:translateY(0);visibility:visible}99%{opacity:0;transform:translateY(-1.5rem);visibility:visible}to{opacity:0;transform:translateY(-1.5rem);visibility:hidden}}skapa-loading skapa-loading-ball{--skapa-loader-message-margin:2.5rem}skapa-loading skapa-loading-linear{--skapa-loader-message-margin:1rem}';
import SkapaElement from '@ingka/skapa-webc-element';
const skapaPrefixRegex = /(?:([^-])|^)skapa-/g;
let lightStyle = lightStyleRaw.toString();
let template;
function getTemplate() {
    if (!template) {
        template = document.createElement('template');
        template.innerHTML = html `<style>${styles}</style>
    <slot></slot>
    <slot name="message" aria-live="polite"></slot>
    <slot name="light-styles"></slot>`
            .replace(skapaPrefixRegex, `$1${config.prefix}-`);
        lightStyle = lightStyle.replace(skapaPrefixRegex, `$1${config.prefix}-`);
    }
    return template;
}
export class Loading extends SkapaElement {
    constructor() {
        super();
        this.gatherProperties(['leading'], this);
        const shadow = this.attachShadow({ mode: 'open' });
        shadow.append(getTemplate().content.cloneNode(true));
    }
    connectedCallback() {
        super.connectedCallback();
        const lightStyles = document.createElement('style');
        lightStyles.slot = 'light-styles';
        lightStyles.innerHTML = lightStyle;
        this.append(lightStyles);
    }
    get leading() {
        return this.hasAttribute('leading');
    }
    set leading(enable) {
        this.toggleAttribute('leading', !!enable);
    }
}
